export const MAX_COUNTER_VALUE: number = 99;
